import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { getInitialStyle, UNFOCUSED_ITEM_ALPHA, FOCUSED_ITEM_ALPHA } from './restrictedInput.style';
import { RestrictedInputItem } from './restrictedInputItem/restrictedInputItem.component';

export class RestrictedInput extends Lightning.Component {
  static _template() {
    return _merge({}, getInitialStyle());
  }

  _init() {
    this._length = 0;
    this._currentItem = 0;
  }

  set length(value) {
    this._length = value;
    this._initializeInput();
  }

  set borderCellColor(color) {
    this.children.forEach(child => {
      child.borderColor = color;
    });
  }

  _initializeInput() {
    const items = [];
    for (let i = 0; i < this._length; i += 1) {
      items.push({ type: RestrictedInputItem });
    }
    this.children = items;
    this.children[this._currentItem].borderAlpha = FOCUSED_ITEM_ALPHA;
  }

  updateBorder() {
    this.children.forEach((child, index) => {
      child.borderAlpha = index === this._currentItem ? FOCUSED_ITEM_ALPHA : UNFOCUSED_ITEM_ALPHA;
    });
  }

  push(value) {
    if (this._currentItem === this._length || !value) return;

    this.children[this._currentItem].itemContent = value;
    this._currentItem += 1;

    this.updateBorder();
  }

  pop() {
    this._currentItem = Math.max(this._currentItem - 1, 0);
    this.children[this._currentItem].clearItemContent();
    this.updateBorder();
  }

  clearInput() {
    this._currentItem = 0;
    this.children.forEach(inputItem => {
      inputItem.clearItemContent();
    });
    this.children[this._currentItem].borderAlpha = FOCUSED_ITEM_ALPHA;
  }
}
